import ApiConfig from "../config/app.config";

/**
 * Rotas para os serviços das APIs consumidas pela aplicação
 */
const apiRoutes = {
  auth: {
    autenticacao: {
      __route: "",
      getCaptcha: { method: "GET", url: "captcha" },
      signInBasic: { method: "GET", url: "efis/signin/basic" },
      signInSso: { method: "GET", url: "efis/signin/sso" },
      signOut: { method: "GET", url: "v1/sso/signout" },
      sessionPasswords: { method: "GET", url: "v1/sso/session-passwords" },
    },
  },
  cadastros: {
    credenciamento: {
      __route: "v1/credenciamento/pedido/",
      dummyPost: { method: "POST", url: "dummy-post/2fa7a9b5-6dd2-42ff-a828-bf45ee18d30c" },
      dummyGet: { method: "GET", url: "dummy-get/2fa7a9b5-6dd2-42ff-a828-bf45ee18d30c" },
    },
  },
  fiscalizacao: {
    arquivos: {
      __route: "v1/auditores/arquivos/",
      upload: { method: "POST", url: "upload" },
    },
    uploads: {
      __route: "",
      uploadExcel: { method: "POST", url: "v1/auditor/acaoFiscal/tasks/uploadExcelEfis" },
      uploadExcelSufac: { method: "POST", url: "v1/auditor/acaoFiscal/tasks/uploadSufacEfis" },
    },
    procedimentoFiscal: {
      __route: "",
      consultaProcedimentoFiscal: { method: "GET", url: "v1/auditor/procedimentoFiscal/pesquisar" },
      consultaHomologaProcedimentoFiscal: { method: "GET", url: "v1/auditor/procedimentoFiscal/lista/homologacao" },
      revisaProcedimentoFiscal: { method: "POST", url: "v1/auditor/procedimentoFiscal/task/revisar" },
      cancelaProcedimentoFiscal: { method: "POST", url: "v1/auditor/procedimentoFiscal/task/cancelar" },
      homologaProcedimentoFiscal: { method: "POST", url: "v1/auditor/procedimentoFiscal/task/homologar" },
      assinaProcedimentoFiscal: { method: "POST", url: "v1/auditor/procedimentoFiscal/task/assinar" },
      listaSetor: { method: "GET", url: "v1/auditor/procedimentoFiscal/lista/setor" },
      listaTipoAcaoFiscal: { method: "GET", url: "v1/auditor/procedimentoFiscal/lista/tipoAcaoFiscal" },
      listaCiclo: { method: "GET", url: "v1/auditor/procedimentoFiscal/lista/ciclo" },
      listaHomologador: { method: "GET", url: "v1/auditor/procedimentoFiscal/lista/homologador" },
      consultaContribuinte: { method: "GET", url: "v1/auditor/procedimentoFiscal/lista/contribuintes" },
      consultaProcedimentosPorAcao: { method: "GET", url: "v1/auditor/procedimentoFiscal/lista/procedimentos" },
      inserirSpf: { method: "POST", url: "v1/auditor/procedimentoFiscal/task/incluir" },
      consultaContribuinteAnexo: {
        method: "POST",
        url: "v1/auditor/procedimentoFiscal/task/lista/contribuintes/anexo",
      },
      listaOrigem: { method: "GET", url: "v1/auditor/procedimentoFiscal/lista/origem" },
      cancelaOrigem: { method: "POST", url: "v1/auditor/procedimentoFiscal/task/origem/cancelar" },
      consultaSpfRevisao: { method: "GET", url: "v1/auditor/procedimentoFiscal/lista/revisao" },
      alterarSpfRevisao: { method: "POST", url: "v1/auditor/procedimentoFiscal/task/alterar" },
      downloadCobranca: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/cobranca/download",
        responseType: "arraybuffer",
      },
      downloadParteServico: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parteServico/download",
        responseType: "arraybuffer",
      },
      downloadDenuncia: { method: "GET", url: "v1/auditor/acaoFiscal/denuncia/download", responseType: "arraybuffer" },
      downloadDocumentoSpf: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/cobranca/download",
        responseType: "arraybuffer",
      },
      consultaAnexoSpf: { method: "GET", url: "v1/auditor/procedimentoFiscal/lista/anexos" },
      assinarSPF: { method: "POST", url: "v1/auditor/procedimentoFiscal/task/assinar" },
      excluirAnexo: { method: "POST", url: "v1/auditor/procedimentoFiscal/task/excluir/anexo" },
      detalhaDenuncia: { method: "GET", url: "v1/auditor/acaoFiscal/denuncia/detalhe" },
      detalheCobranca: { method: "GET", url: "v1/auditor/acaoFiscal/cobranca/detalhe" },
      documentoHtml: { method: "GET", url: "v1/auditor/procedimentoFiscal/documentohtml" },
      buscatextopadraospf: { method: "GET", url: "v1/auditor/procedimentoFiscal/buscatextopadraospf" },
      verificaDenuncia: { method: "GET", url: "v1/auditor/acaoFiscal/denuncia/verificadenuncia" },
      encerrarDenuncia: { method: "POST", url: "v1/auditor/denuncia/task/encerrar" },
      consultaProcedimentosPorAcaoAberta: {
        method: "GET",
        url: "v1/auditor/procedimentoFiscal/lista/procedimentosaberta",
      },
    },
    parametrizacao: {
      __route: "",
      consultaCiclo: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/ciclo" },
      alteraCiclo: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/ciclo/alterar" },
      incluiCiclo: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/ciclo/incluir" },
      excluiCiclo: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/ciclo/excluir" },
      consultaTipoAcaoFiscal: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/tipoAcaoFiscal" },
      consultaListaRoteiro: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/roteiro" },
      insereTipoAcaoFiscal: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipoAcaoFiscal/incluir" },
      excluiTipoAcaoFiscal: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipoAcaoFiscal/excluir" },
      alteraTipoAcaoFiscal: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipoAcaoFiscal/alterar" },
      consultaProcedimento: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/procedimento" },
      consultaLivroFiscal: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/livrofiscal" },
      consultaTipoCarga: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/tipocarga" },
      alteraProcedimento: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/procedimento/alterar" },
      alteraLivroFiscal: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/livrofiscal/alterar" },
      incluiProcedimento: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/procedimento/incluir" },
      incluiLivroFiscal: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/livrofiscal/incluir" },
      excluiProcedimento: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/procedimento/excluir" },
      excluiLivroFiscal: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/livrofiscal/excluir" },
      consultaTextoPadrao: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/textopadrao" },
      consultaTipoAcao: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/tipoacao" },
      alteraTextoPadrao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/textopadrao/alterar" },
      incluiTextoPadrao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/textopadrao/incluir" },
      excluiTextoPadrao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/textopadrao/excluir" },
      consultaFase: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/fase" },
      alteraFase: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/fase/alterar" },
      incluiFase: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/fase/incluir" },
      excluiFase: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/fase/excluir" },
      consultaAtividadePadrao: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/atividadepadrao" },
      buscaAtividadePadrao: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/atividadepadrao/consultar" },
      incluiAtividadePadrao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/atividade-padrao/incluir" },
      alteraAtividadePadrao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/atividade-padrao/alterar" },
      excluiAtividadePadrao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/atividade-padrao/excluir" },
      inativaAtividadePadrao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/atividade-padrao/inativar" },
      reativaAtividadePadrao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/atividade-padrao/reativar" },
      consultaSiglas: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/siglas/lista" },
      consultaRoteiros: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/roteiros/lista" },
      consultaFases: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/fases" },
      consultaFuncionalidades: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/funcionalidades" },
      consultaCamposAtividadePadrao: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parametrizacao/atividadepadrao/campos",
      },
      selectItems: { method: "GET", url: "v1/auditor/acaoFiscal/select-items" },
      consultaRoteiro: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/consultar" },
      alteraRoteiro: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/alterar" },
      incluiRoteiro: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/incluir" },
      excluiRoteiro: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/excluir" },
      listaAtividadesRoteiro: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/consultar/atividades/lista",
      },
      associacaoAtividadesRoteiro: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/consultar/associacao/atividades",
      },
      associarAtividadesRoteiro: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/associar-atividades",
      },
      desassociarAtividadeRoteiro: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/desassociar-atividade",
      },
      listaOrdenacaoAtividadeRoteiro: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/consultar/ordenacao/atividade",
      },
      incluirOrdenacaoRoteiro: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/incluir-ordenacao",
      },
      excluirOrdenacaoRoteiro: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/excluir-ordenacao",
      },
      consultaResumoRoteiro: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/roteiro/consultar/resumo" },
      consultaModeloImportacao: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/modeloimportacao" },
      alteraModeloImportacao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/modeloimportacao/alterar" },
      incluiModeloImportacao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/modeloimportacao/incluir" },
      excluiModeloImportacao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/modeloimportacao/excluir" },
      associarOcorrenciaModeloImportacao: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/parametrizacao/modeloimportacao/associarocorrencia",
      },
      desassociarOcorrenciaModeloImportacao: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/parametrizacao/modeloimportacao/desassociarocorrencia",
      },
      consultaOcorrenciasGeral: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parametrizacao/modeloimportacao/ocorrencias",
      },
      consultaTipoDetalhamento: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parametrizacao/tipodetalhamento",
      },
      consultaTipoDivergencia: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/tipodivergencia" },
      alteraTipoDivergencia: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipodivergencia/alterar" },
      incluiTipoDivergencia: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipodivergencia/incluir" },
      excluiTipoDivergencia: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipodivergencia/excluir" },
      consultaCriticasTipoDivergencia: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parametrizacao/criticastipodivergencia",
      },
      consultaTodasCriticasTipoDivergencia: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parametrizacao/todascriticastipodivergencia",
      },
      consultaOutrasCriticasTipoDivergencia: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parametrizacao/outrascriticastipodivergencia",
      },
      desassociarCriticaTipoDivergencia: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/parametrizacao/tipodivergencia/desassociarcritica",
      },
      consultarOcorrencia: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/ocorrencia/consultar" },
      incluirOcorrencia: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/ocorrencia/incluir" },
      alterarOcorrencia: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/ocorrencia/alterar" },
      excluirOcorrencia: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/ocorrencia/excluir" },
      revisarOcorrencia: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/ocorrencia/revisar" },
      clonarOcorrencia: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/ocorrencia/clonar" },
      consultaTextoParteServico: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/textoparteservico" },
      alteraTextoParteServico: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/parametrizacao/textoparteservico/alterar",
      },
      incluiTextoParteServico: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/parametrizacao/textoparteservico/incluir",
      },
      excluiTextoParteServico: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/parametrizacao/textoparteservico/excluir",
      },
      consultaTipoParteServico: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/tipoparteservico" },
      alteraTipoParteServico: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipoparteservico/alterar" },
      incluiTipoParteServico: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipoparteservico/incluir" },
      excluiTipoParteServico: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipoparteservico/excluir" },
      consultaTipoInaptidao: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/tipoinaptidao" },
      alteraTipoInaptidao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipoinaptidao/alterar" },
      incluiTipoInaptidao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipoinaptidao/incluir" },
      excluiTipoInaptidao: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/tipoinaptidao/excluir" },
      consultaAtividadePadraoAF: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/textopadraoidacaofiscal" },
      listaOrgao: { method: "GET", url: "v1/auditor/acaoFiscal/select-items/orgao" },
      consultaExpedienteAtipico: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/pontofacultativo" },
      listaExpedienteAtipico: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/feriadospat" },
      alteraExpedienteAtipico: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/pontofacultativo/alterar" },
      incluiExpedienteAtipico: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/pontofacultativo/incluir" },
      excluiExpedienteAtipico: { method: "POST", url: "v1/auditor/acaoFiscal/parametrizacao/pontofacultativo/excluir" },
      listaUfs: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/ufs" },
      listaMunicipios: { method: "GET", url: "v1/auditor/acaoFiscal/parametrizacao/uf/municipios" },
    },
    prorrogacaoos: {
      __route: "",
      prorrogacaoOs: { method: "GET", url: "v1/auditor/acaoFiscal/prorrogacaoos/prorrogacao" },
      andamentoProrrogacaoOs: { method: "GET", url: "v1/auditor/acaoFiscal/prorrogacaoos/andamentoProrrogacao" },
      ultimaatividadeprorrogacao: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/prorrogacaoos/ultimaatividadeprorrogacao",
      },
      solicitarProrrogacaoOs: { method: "POST", url: "v1/auditor/prorrogacaoos/task/solicitarprorrogacaoos" },
      excluirProrrogacaoOs: { method: "POST", url: "v1/auditor/prorrogacaoos/task/excluirprorrogacaoos" },
      assinarSolicitarProrrogacaoOs: {
        method: "POST",
        url: "v1/auditor/prorrogacaoos/task/assinar/solicitarprorrogacaoos",
      },
      prorrogarOs: { method: "POST", url: "v1/auditor/prorrogacaoos/task/prorrogaros" },
      assinarProrrogarOs: { method: "POST", url: "v1/auditor/prorrogacaoos/task/assinar/prorrogaros" },
      incluirAtividadeProrrogacao: { method: "POST", url: "v1/auditor/prorrogacaoos/task/incluir/atividade" },
      alterarAtividadeProrrogacao: { method: "POST", url: "v1/auditor/prorrogacaoos/task/alterar/atividade" },
      assinarAtividade: { method: "POST", url: "v1/auditor/prorrogacaoos/task/assinar/atividade" },
      excluirAtividade: { method: "POST", url: "v1/auditor/prorrogacaoos/task/excluir/atividade" },
      cancelarAtividade: { method: "POST", url: "v1/auditor/prorrogacaoos/task/cancelar/atividade" },
      downloadDocumentoPadraoProrrogacao: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/prorrogacaoos/download",
        responseType: "arraybuffer",
      },
      andamentoProrrogacaoOsHtml: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/prorrogacaoos/andamentoProrrogacaoOsHtml",
      },
      documentoAtividade: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/prorrogacaoos/documentoAtividade",
        responseType: "arraybuffer",
      },
    },
    ordemservico: {
      __route: "",
      inserirOs: { method: "POST", url: "v1/auditor/ordemservico/task/incluir" },
      inserirOsSpf: { method: "POST", url: "v1/auditor/ordemservico/task/incluir/listaspf" },
      consultaDiretor: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/listadiretor" },
      consultaFase: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/listafases" },
      consultaExecutores: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/executores" },
      consultaOsExecutar: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/listaosexecutar" },
      consultaDadosOs: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/lista" },
      downloadDocumentoOs: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ordemservico/download",
        responseType: "arraybuffer",
      },
      imprimeDemonstOcorrenciaSigat: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ordemservico/imprimeOcorrenciaSigat",
      },
      gerarDocumentoDemonstOcorrencia: {
        method: "POST",
        url: "v1/auditor/ordemservico/task/gerarDemonstrativoOcorrenciaEfis",
      },
      consultaSpfHomologada: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/lista/spf" },
      consultaOrgaoLogado: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/orgaousuariologado" },
      consultaTipoAcaoSpf: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/tipoacaofiscal" },
      atribuirProcesso: { method: "POST", url: "v1/auditor/ordemservico/task/atribuirprocesso" },
      listaOrigemOs: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/lista/origem" },
      tomarCienciaOs: { method: "POST", url: "v1/auditor/ordemservico/task/tomarcienciaos" },
      cancelaDocumentoOs: { method: "POST", url: "v1/auditor/ordemservico/task/cancelaros" },
      verificaOrdemServico: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/verificaordemservico" },
      verificaDemonstrativoOcorrencia: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ordemservico/verificademonstrativoocorrencia",
      },
      existeAtividade: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/existeatividade" },
      andamentoOs: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/andamento" },
      proximasAtividades: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/proximasAtividades" },
      incluirAtividade: { method: "POST", url: "v1/auditor/ordemservico/task/incluir/atividade" },
      alterarAtividade: { method: "POST", url: "v1/auditor/ordemservico/task/alterar/atividade" },
      excluirAnexoAtividade: { method: "POST", url: "v1/auditor/ordemservico/task/excluir/anexo" },
      patExistenteOs: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/patexistente" },
      patOcorrenciasOs: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/patocorrencias" },
      assinarAtividade: { method: "POST", url: "v1/auditor/ordemservico/task/assinar/atividade" },
      andamentoAtividade: { method: "POST", url: "v1/auditor/ordemservico/task/andamento/atividade" },
      substituirTexto: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/substituirtexto" },
      cancelarAtividade: { method: "POST", url: "v1/auditor/ordemservico/task/cancelar/atividade" },
      excluirAtividade: { method: "POST", url: "v1/auditor/ordemservico/task/excluir/atividade" },
      consultaImpedimentos: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/lista/impedimentos" },
      consultaLivrosFiscais: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/lista/livrosFiscais" },
      consultaLivrosFiscaisSalvos: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ordemservico/lista/livrosFiscaisSalvos",
      },
      documentoAndamento: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/documentoandamento" },
      documentoAndamentoCiencia: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/documentoandamentociencia" },
      documentoAndamentoOs: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/documentoandamentoos" },
      verificaContribuinte: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/verificaContribuinte" },
      verificaInatividade: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/verificaInatividade" },
      incluirAltExecutor: { method: "POST", url: "v1/auditor/ordemservico/task/incluir/altexecutor" },
      alterarAltExec: { method: "POST", url: "v1/auditor/ordemservico/task/alterar/altexecutor" },
      excluirAltExec: { method: "POST", url: "v1/auditor/ordemservico/task/excluir/altexecutoros" },
      assinarAltExec: { method: "POST", url: "v1/auditor/ordemservico/task/assinar/altexecutor" },
      consultaExecutorAf: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/lista/executoraf" },
      excluirExecutorAf: { method: "POST", url: "v1/auditor/ordemservico/task/excluir/executoraf" },
      consultaRepresentante: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/consultarepresentante" },
      outrasAcoesFiscais: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/outrasacoesfiscais" },
      listaTAM: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/listatam" },
      listaCobranca: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/listacobranca" },
      listaItinerancia: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/listaitineranciaacao" },
      consultaGrupoDocumento: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/grupodocumento" },
      responsabilidadeOrgao: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/retornaresponsabilidadeorgao" },
      listatsps: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/lista/tsps" },
      buscaaltrepresentantetsps: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/lista/altassociacaotsps" },
      excluirtsps: { method: "POST", url: "v1/auditor/ordemservico/task/excluir/associacaotsps" },
      inserirtsps: { method: "POST", url: "v1/auditor/ordemservico/task/incluir/associacaotsps" },
      alterartsps: { method: "POST", url: "v1/auditor/ordemservico/task/alterar/associacaotsps" },
      assinarParteServicoOs: { method: "POST", url: "v1/auditor/ordemservico/task/assinar/parteservicoos" },
      incluirParteServicoOs: { method: "POST", url: "v1/auditor/ordemservico/task/incluir/parteservicoos" },
      alterarParteServicoOs: { method: "POST", url: "v1/auditor/ordemservico/task/alterar/parteservicoos" },
      consultarOs: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/listaosconsultar" },
      consultarOSInformacaoSintetica: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ordemservico/listaosconsultarinformacaosintetica",
      },
      gerarOrdemServico: { method: "POST", url: "v1/auditor/ordemservico/task/gerarordemservico" },
      consultarAnexosAtividade: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/lista/anexosatividade" },
      listarinformacaosinteticaos: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ordemservico/lista/informacaosinteticaos",
      },
      consultaExecutorOs: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ordemservico/listaexecutorordemservico",
      },
      consultaContribuinteIcms: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/contribuinte/consulta",
      },
      downloadContribuinteIcms: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/contribuinte/download",
        responseType: "arraybuffer",
      },
      spedEnvioEfd: { method: "GET", url: "v1/auditor/acaoFiscal/sped/envioefd" },
      downloadEnvioSpedEfdSintetico: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/sped/enviosspedefdsintetico",
        responseType: "arraybuffer",
      },
      downloadEnvioSpedEfdAnalitico: {
        method: "POST",
        url: "v1/auditor/acaoFiscal/sped/enviosspedefdanalitico",
        responseType: "arraybuffer",
      },
      documentoHtml: { method: "GET", url: "v1/auditor/acaoFiscal/ordemservico/documentohtml" },
      buscatextopadraoos: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ordemservico/buscatextopadraoos",
      },
      listarOcorrenciasRefc: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ordemservico/ocorrenciasrefc",
      },
      imprimirOcorrenciasRefc: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ordemservico/imprimirocorrenciasrefc",
        responseType: "arraybuffer",
      },
      gerarComunicado: { method: "POST", url: "v1/auditor/ordemservico/task/gerarcomunicado" },
      gerarDocAutoInfracaoSigat: {
        method: "POST",
        url: "v1/auditor/ordemservico/task/gerar/docautoinfracaosigat",
        responseType: "arraybuffer",
      },
      gerarVisualizacaoDocumento: {
        method: "POST",
        url: "v1/auditor/ordemservico/task/gerarVisualizacaoDocumento",
        responseType: "arraybuffer",
      },
      gerarDocAutoInfracaoParaVisualizar: {
        method: "POST",
        url: "v1/auditor/ordemservico/task/gerar/visualizacaoDocAutoInfracao",
        responseType: "arraybuffer",
      },
    },
    pat: {
      __route: "",
      consultarPat: { method: "GET", url: "v1/auditor/pat/processo/listapatconsultar" },
      listaOrgaoUrt: { method: "GET", url: "v1/auditor/pat/processo/listaorgaourt" },
      debitosConsolidadoPat: {
        method: "GET",
        url: "v1/auditor/pat/processo/consolidacaoDebitosPat",
        responseType: "arraybuffer",
      },
      debitosSinteticoPat: {
        method: "GET",
        url: "v1/auditor/pat/processo/sinteticoDebitosPat",
        responseType: "arraybuffer",
      },
      consultarDadosProcesso: { method: "GET", url: "v1/auditor/pat/processo/consultardadosprocesso" },
      listaMomentoDisponivel: { method: "GET", url: "v1/auditor/pat/processo/listamomentosdisponiveis" },
      listaMomentoCiencia: { method: "GET", url: "v1/auditor/pat/processo/listamomenciencia" },
      adicionarMomentoCiencia: { method: "POST", url: "v1/auditor/pat/processo/adicionarmomenciencia" },
    },
    alteracaoexecutor: {
      __route: "",
      incluirAtividade: { method: "POST", url: "v1/auditor/alteracaoexecutor/task/incluir/atividade" },
      alterarAtividade: { method: "POST", url: "v1/auditor/alteracaoexecutor/task/alterar/atividade" },
      excluirAtividade: { method: "POST", url: "v1/auditor/alteracaoexecutor/task/excluir/atividade" },
      assinarAtividade: { method: "POST", url: "v1/auditor/alteracaoexecutor/task/assinar/atividade" },
      cancelarAtividade: { method: "POST", url: "v1/auditor/alteracaoexecutor/task/cancelar/atividade" },
      consultaExecutorAltExcOs: { method: "GET", url: "v1/auditor/acaoFiscal/alteracaoexecutor/lista/altexecos" },
      consultaExecutorAltExc: { method: "GET", url: "v1/auditor/acaoFiscal/alteracaoexecutor/lista/altexec" },
      consultaExecutorAltExcExclusao: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/alteracaoexecutor/lista/altexecdel",
      },
      excluirAltExecOs: { method: "POST", url: "v1/auditor/alteracaoexecutor/task/excluir/altexecutoros" },
      substituirTexto: { method: "GET", url: "v1/auditor/acaoFiscal/alteracaoexecutor/substituirtexto" },
      consultaAlteracaoExecutores: { method: "GET", url: "v1/auditor/acaoFiscal/alteracaoexecutor/lista" },
      andamentoAlterExec: { method: "GET", url: "v1/auditor/acaoFiscal/alteracaoexecutor/andamentos" },
      excluirAnexoAtividade: { method: "POST", url: "v1/auditor/alteracaoexecutor/task/excluir/anexo" },
      excluirAlteracao: { method: "POST", url: "v1/auditor/alteracaoexecutor/task/excluir" },
      anexosAtividade: { method: "GET", url: "v1/auditor/acaoFiscal/alteracaoexecutor/lista/anexosalteracao" },
      andamentoAlteracaoExecutorHtml: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/alteracaoexecutor/andamentoAlteracaoExecutorHtml",
      },
    },
    parteservico: {
      __route: "",
      listaParteServico: { method: "GET", url: "v1/auditor/acaoFiscal/parteServico/listaparteservico" },
      getTextoParteServico: { method: "GET", url: "v1/auditor/acaoFiscal/parteServico/textoparteservico" },
      verificaParteServico: { method: "GET", url: "v1/auditor/acaoFiscal/parteServico/verificaparteservico" },
      inserirParteServico: { method: "POST", url: "v1/auditor/parteservico/task/incluir" },
      alterarParteServico: { method: "POST", url: "v1/auditor/parteservico/task/alterar" },
      excluirParteServico: { method: "POST", url: "v1/auditor/parteservico/task/excluir" },
      encerrarParteServico: { method: "POST", url: "v1/auditor/parteservico/task/encerrar" },
      documentoHtml: { method: "GET", url: "v1/auditor/acaoFiscal/parteServico/documentohtml" },
      anexosParteServico: { method: "GET", url: "v1/auditor/acaoFiscal/parteServico/anexoparteservico" },
      excluirAnexoParteServico: { method: "POST", url: "v1/auditor/parteservico/task/excluiranexos" },
      listaParteServicoPv: { method: "GET", url: "v1/auditor/acaoFiscal/parteServico/listaparteservicopv" },
      downloadDocumentoPS: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/parteServico/downloadps",
        responseType: "arraybuffer",
      },
    },
    ocorrencia: {
      __route: "",
      listaTipoOcorrencia: { method: "GET", url: "v1/auditor/acaoFiscal/ocorrencia/consultar/tipoocorrencia" },
      inserirOcorrencia: { method: "POST", url: "v1/auditor/ocorrencia/task/incluir" },
      alterarOcorrencia: { method: "POST", url: "v1/auditor/ocorrencia/task/alterar" },
      incluirDemonstrativo: { method: "POST", url: "v1/auditor/ocorrencia/task/demonstrativo/incluir" },
      alterarDemonstrativo: { method: "POST", url: "v1/auditor/ocorrencia/task/demonstrativo/alterar" },
      consultarOcorrencia: { method: "GET", url: "v1/auditor/acaoFiscal/ocorrencia/consultar/ocorrencia" },
      listaDemonstrativoOcorrencia: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ocorrencia/consultar/demonstrativoocorrencia",
      },
      consultarDemonstrativo: { method: "GET", url: "v1/auditor/acaoFiscal/ocorrencia/consultar/demonstrativo" },
      excluirItemOcorrencia: { method: "POST", url: "v1/auditor/ocorrencia/task/excluir" },
      buscaComposicao: { method: "GET", url: "v1/auditor/acaoFiscal/ocorrencia/retorna/composicao" },
      excluirItemDemonstrativo: { method: "POST", url: "v1/auditor/ocorrencia/task/excluirItemDemonstrativo" },
      excluirListaItensDemonstrativo: {
        method: "POST",
        url: "v1/auditor/ocorrencia/task/excluirListaItensDemonstrativo",
      },
      listaDemonstrativoExtratoFiscal: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ocorrencia/consultar/demonstrativoextratofiscal",
      },
      gerarResumoOcorrencia: {
        method: "POST",
        url: "v1/auditor/ocorrencia/task/gerar/resumoocorrencia",
        responseType: "arraybuffer",
      },
      gerarDemonstrativoOcorrencia: {
        method: "POST",
        url: "v1/auditor/ocorrencia/task/gerar/demonstrativoocorrencia",
        responseType: "arraybuffer",
      },
      consultaDocumentosFiscais: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ocorrencia/consultar/documentosfiscais",
      },
      downloadDocumento: {
        method: "GET",
        url: "v1/auditor/acaoFiscal/ocorrencia/downloaddocumento",
        responseType: "arraybuffer",
      },
      verificaResultado: { method: "GET", url: "v1/auditor/acaoFiscal/ocorrencia/verificaresultado" },
      
    },
    autoinfracao: {
      __route: "",
      consultaAutoInfracaoEsp: { method: "GET", url: "v1/auditor/acaoFiscal/autoinfracao/listaautoinfracaoesp" },
      consultaOcorrenciaOs: { method: "GET", url: "v1/auditor/acaoFiscal/autoinfracao/listaocorrenciaos" },
      incluirAtividadeInicial: {
        method: "POST",
        url: "v1/auditor/autoinfracao/task/incluir/atividadeinicial",
      },
      alterarAtividadeInicial: {
        method: "POST",
        url: "v1/auditor/autoinfracao/task/alterar/atividadeinicial",
      },
      cancelarAutoInfracao: {
        method: "POST",
        url: "v1/auditor/autoinfracao/task/cancelar/autoinfracao",
      },
      andamentoautoinfracaoesp: { method: "GET", url: "v1/auditor/acaoFiscal/autoinfracao/andamentoautoinfracaoesp" },
      assinarAtividadeInicial: {
        method: "POST",
        url: "v1/auditor/autoinfracao/task/assinar/atividadeinicial",
      },
      cancelarAndamento: {
        method: "POST",
        url: "v1/auditor/autoinfracao/task/cancelar/andamento ",
      },
      incluirAtividadePadrao: {
        method: "POST",
        url: "v1/auditor/autoinfracao/task/incluir/atividadepadrao ",
      },
      alterarAtividadePadrao: {
        method: "POST",
        url: "v1/auditor/autoinfracao/task/alterar/atividadepadrao ",
      },
      excluirAtividadePadrao: {
        method: "POST",
        url: "v1/auditor/autoinfracao/task/excluir/atividadepadrao ",
      },
      assinarAtividadePadrao: {
        method: "POST",
        url: "v1/auditor/autoinfracao/task/assinar/atividadepadrao ",
      },
    },
  },
  usuarios: {
    menu: {
      __route: "v1/set/efis/menu",
      consulta: { method: "POST", url: "" },
    },
    notificacao: {
      __route: "v1/notificacao/",
      listar: { method: "GET", url: "listar" },
      listarnotificacaoefis: { method: "GET", url: "listarnotificacaoefis" },
      marcarComoLidas: { method: "POST", url: "lidas" },
      marcarComoApagadas: { method: "POST", url: "apagadas" },
    },
    arquivo: {
      __route: "v1/arquivo/",
      fila: { method: "GET", url: "assinatura/fila" },
      download: { method: "GET", url: "download/:ticket" },
      info: { method: "GET", url: "info/:ticket" },
      assinatura: { method: "GET", url: "assinatura/:ticket" },
      certificado: { method: "GET", url: "cert/:fingerprint" },
      selecionar: { method: "POST", url: "selecionar" },
    },
  },
  extratofiscal: {
    extrato: {
      __route: "v1/",
      consulta: { method: "GET", url: "consulta" },
      detalheDebitosVencidos: { method: "GET", url: "vencidos" },
      detalheDebitosAVencer: { method: "GET", url: "avencer" },
      detalhePat: { method: "GET", url: "pat" },
      imprimirExtrato: { method: "GET", url: "download", responseType: "arraybuffer" },
    },
  },
  nfp: {
    reclamacao: {
      __route: "v1/reclamacao/",
      listarReclamacao: { method: "GET", url: "reclamacoesempresa" },
    },
  },
};

const prepare = (routes) => {
  const routesToPrepare = routes;
  Object.keys(routesToPrepare).forEach((host) => {
    Object.keys(routesToPrepare[host]).forEach((controller) => {
      Object.keys(routesToPrepare[host][controller]).forEach((action) => {
        if (action === "__route") return;

        routesToPrepare[host][controller][
          action
        ].url = `${ApiConfig.hosts[host]}${routesToPrepare[host][controller].__route}${routesToPrepare[host][controller][action].url}`;
      });
    });
  });

  return routesToPrepare;
};

const preparedRoutes = prepare(apiRoutes);

export default preparedRoutes;
